import { gql } from "@apollo/client";

export const QUERY_STUDENT_METRICS_REPORT = gql`
  query (
      $schoolIds: [ID], 
      $selectedFields: [String],
    ) {
    studentMetricsReport(
      schoolIds: $schoolIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
